import type {
    RewardsEarningRulesEntity,
    RewardsEarningRulesRewardEntity,
} from "@apps/rewards/modules/EarningRules/models/RewardsEarningRulesEntities";

import type { EarningRulesRewardDTO, EarningRulesSdkResultDTO } from "../types";

const mapRewardToDto = (
    rewarding: RewardsEarningRulesRewardEntity
): EarningRulesRewardDTO => {
    switch (rewarding.type) {
        case "points": {
            if ("amountSpent" in rewarding) {
                return {
                    type: "points",
                    points: rewarding.points,
                    amountSpent: rewarding.amountSpent,
                };
            }
            return {
                type: "points",
                points: rewarding.points,
            };
        }
        case "discount":
            return {
                type: rewarding.type,
                discountValue: rewarding.discountValue,
            };
        case "gift_card":
            return {
                type: rewarding.type,
                initialValue: rewarding.initialValue,
            };
        case "free_product":
            return {
                type: rewarding.type,
                productTitle: rewarding.productTitle,
                discountValue: rewarding.discountValue,
                productImage: rewarding.productImage,
            };

        default:
            throw new Error("Unknown type");
    }
};

export const mapEarningRulesToDto = (
    items: Array<RewardsEarningRulesEntity>
): Array<EarningRulesSdkResultDTO> =>
    items.map((item) => ({
        id: item.id,
        title: item.title,
        description: item.description,
        rewarding: mapRewardToDto(item.rewarding),
        icon: item.icon,
        completed: item.completed,
        type: item.type,
    }));
